import script from "./UserWorkspaces.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserWorkspaces.vue?vue&type=script&lang=ts&setup=true"

import "./UserWorkspaces.vue?vue&type=style&index=0&id=6be6394e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6be6394e"]])

export default __exports__